import { Link } from 'react-router-dom';
import { newsList } from '@/mocks/news';

const tickerItems = newsList.slice(0, 8);
const loopItems = [...tickerItems, ...tickerItems];

function LiveTicker() {
  return (
    <section aria-label="实时快讯滚动条" className="border-y border-background-200/80 bg-background-100">
      <div className="flex items-stretch">
        <div className="flex shrink-0 items-center gap-2 bg-accent-500 px-4 py-3 text-background-50 md:px-6">
          <i className="ri-broadcast-line text-lg" />
          <span className="whitespace-nowrap font-heading text-sm font-bold">实时快讯</span>
        </div>
        <div className="relative flex-1 overflow-hidden">
          <div className="flex w-max animate-marquee items-center">
            {loopItems.map((item, index) => (
              <Link
                key={`${item.id}-${index}`}
                to={`/topic/${item.topicSlug}`}
                className="flex shrink-0 items-center gap-2 whitespace-nowrap px-5 text-sm text-foreground-700 transition-colors hover:text-primary-700"
              >
                <span className="text-xs text-accent-600">{item.time}</span>
                <span>{item.title}</span>
                <span className="text-foreground-300">/</span>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}

export default LiveTicker;